import { routePaths } from 'components/Routes/data';
import RestrictedRoute from 'components/Routes/RestrictedRoute';
import React from 'react';
import { Redirect, Switch, useLocation } from 'react-router-dom';
import { KycInfo } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/KycInfo';
import { StatutoryInfo } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/StatutoryInfo';
import { PersonalDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/PersonalDetails';
import { ReviewDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/ReviewDetails';
import { Box, Modal, ModalBody, Spinner } from '@razorpay/blade/components';
import {
  SidebarContentWrapper,
  MultiStepFormWrapper,
  MainContentWrapper,
} from 'components/EmployeeOnboarding/components/styles';
import { OnboardingSidebar } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/components/OnboardingSidebar';
import { BankAccountDetails } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/BankAccountDetails';
import { FormProvider } from 'forms';
import { useSavedEmployeeData } from './hooks/useSavedEmployeeData';
import { WizardInfoProvider } from 'components/WizardViews/providers/WizardInfoProvider';
import { routeToStepMap } from './constants';
import WizardPathToStepController from 'components/WizardViews/components/WizardPathToStepController';
import { Wizard, WizardStep } from 'forms/Wizard';

export const EmployeeSelfOnboarding = () => {
  const location = useLocation();

  const { isLoadingQuery, selfOnboardingFormInitialData, shouldShowStatutoryDetailsStep } = useSavedEmployeeData();

  if (location.pathname === routePaths.employeeOnboarding.employeeSelfOnboarding.root) {
    return <Redirect to={routePaths.employeeOnboarding.employeeSelfOnboarding.kycDetails} />;
  }

  if (isLoadingQuery) {
    return (
      <Box display="flex" height="80vh" alignItems="center" justifyContent="center">
        <Spinner accessibilityLabel="Loading" />
      </Box>
    );
  }

  return (
    <Box>
      <Modal isOpen={true} onDismiss={() => {}} size="full">
        <ModalBody padding="spacing.0">
          <FormProvider initialState={selfOnboardingFormInitialData}>
            <WizardInfoProvider beginStep={1} initialStep={1} totalSteps={5}>
              <MultiStepFormWrapper>
                <SidebarContentWrapper>
                  <OnboardingSidebar shouldShowStatutoryDetailsStep={shouldShowStatutoryDetailsStep} />
                </SidebarContentWrapper>
                <MainContentWrapper>
                  <WizardPathToStepController routeStepMap={routeToStepMap} />
                  <Switch>
                    <Wizard>
                      <WizardStep step={1} component={KycInfo} />
                      <WizardStep step={2} component={BankAccountDetails} />
                      <WizardStep step={3} component={StatutoryInfo} />
                      <WizardStep step={4} component={PersonalDetails} />
                      <WizardStep step={5} component={ReviewDetails} />
                    </Wizard>
                  </Switch>
                </MainContentWrapper>
              </MultiStepFormWrapper>
            </WizardInfoProvider>
          </FormProvider>
        </ModalBody>
      </Modal>
    </Box>
  );
};
